type QuestionIdMap = Map<string, unknown>;

export function getQuestionIdsForTestGeneration({
  questions,
}: {
  questions: QuestionIdMap;
}): string[] {
  return Array.from(questions.keys());
}
